<template>
	<header :style="styleObject" :class="[ isClassHomeAndNotItemPage ? 'header-home' : 'header-section' ]">
		<div class="header-info">
			<div v-if="course.COURSE_TITLE" :class="`text-${ textColor }`"
					 class="title"
					 id="course-grades-title">
				<span>
					{{course.COURSE_TITLE}}
				</span>
			</div>
			<span v-if="course.TEACHER_NAME" :class="`header-text text-${ textColor }`">{{ course.TEACHER_NAME }}</span> 
			<a :href="`mailto:${details.EMAIL}`" v-if="details.EMAIL" :class="`btn-unstyled text-${ textColor }`">
				<i class="fas fa-envelope" aria-hidden="true"></i>
				<span class="sr-only">
					{{ $t( 'MAIN_CONTENT.classPage.Header.teacherEmail', { teacher: course.TEACHER_NAME } ) }}
				</span>
			</a>
		</div>
		<page-icon v-bind="currentIconProps"></page-icon>
		<div class="header-overlay" :style="{ backgroundColor : bgColor }" v-if="isClassHomeAndNotItemPage"></div>
		<nav class="class-menu" aria-label="Class Options" v-if="menu.length > 0">
			<ul class="nav navbar-nav navbar-right">
				<li>
					<button type="button"
									:style="`color:${ textColor };`"
									:class="{ 'active' : isMenuActive, 'btn-unstyled class-menu-btn text' : true }"
									@click="toggleClassNav()">
						<span class="bento" aria-hidden="true">
							<i class="fas fa-ellipsis-v"></i>
							<i class="fas fa-ellipsis-v"></i>
							<i class="fas fa-ellipsis-v"></i>
						</span>
						{{ $t( 'MAIN_CONTENT.classPage.Header.classPage_classMenu' ) }}
					</button>
					<div v-show="isMenuActive" class="header-dropdown">
						<div class="header-dropdown-menu">
							<class-nav :course="course" :menu="menu" :current-section="currentSection" :course-content="courseContent">
							</class-nav>
						</div>
					</div>
				</li>
			</ul>
		</nav>
	</header>
</template>

<script>
	import { mapState } from 'vuex';
	import ClassNav from './ClassNav.vue';
	import PageIcon from './PageIcon.vue';

	export default {
		components: {
			PageIcon,
			ClassNav
		},
		props: {
			currentSection : {
				type : Number,
				default: 0
			},
			course: {
				type: Object,
				default: () => {},
			},
			details: {
				type: Object,
				default: () => {},
			},
			menu: {
				type: Array,
				default: () => [],
			},
			courseContent: {
				type: Object,
				default: () => {},
			},
			isClassItemPage: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				mediaPath: '/CommunityWebPortal/_app/includes/static/images/profiles/',
				isMenuActive: false
			};
		},
		computed: {
				isClassHome() {
					return this.currentSection === 0;
				},
				isClassHomeAndNotItemPage() {
					return this.currentSection === 0 && !this.isClassItemPage;
				},
				currentIndex() {
					if( this.currentSection == 0 ) {
						return -1;
					} else {
						return  this.menu.findIndex( item => item.FOLDER_ID === this.currentSection );
					}
				},
				textColor(){
					if( !this.isClassHomeAndNotItemPage ) {
						return 'black';
					} else if( !!this.details.FONT_COLOR && this.isClassHome ) {
						return `${this.details.FONT_COLOR}`;
					} else {
						return 'white';
					}
				},
				bgColor() {
					if( !this.isClassHomeAndNotItemPage ) {
						return '#ffffff';
					} else if( !!this.details.BACKGROUND_COLOR && this.isClassHome && !this.details.BACKGROUND_URL ) {
						return `${this.details.BACKGROUND_COLOR}`;
					} else {
						return '';
					}
				},
				bgImage() {
					if( !!this.details.BACKGROUND_URL && this.isClassHome ) {
						return this.details.BACKGROUND_URL;
					}
				},
				styleObject() {
					return {
						backgroundColor: `${this.bgColor}`,
						backgroundImage: this.bgImage ? 'url(' + this.bgImage + ')' : 'none',
						marginBottom: '70px',
						paddingBottom: this.desktopView ? '10px' : '70px'
					}
				},
			currentIconProps() {
				let current = {};
				if(this.isClassHome && !!this.courseContent && this.courseContent.hasOwnProperty("PAGE_ICON_URL")){
					current.image = 'url(' + this.courseContent.PAGE_ICON_URL + ')';
					current.text = '';
				}
				else if( this.isClassHome && this.course.TEACHER_IMAGE ){
					current.image = 'url(' + this.mediaPath + this.course.TEACHER_IMAGE + ')';
				} else if( this.isClassHome && !this.course.TEACHER_IMAGE ) {
					current.image = 'url(' + this.mediaPath + 'no-staff-image.png )';
				}
				else {
					current.text = '';
					
					if(!!this.menu[this.currentIndex]) {
						if(!!this.menu[this.currentIndex].FOLDER_NAME) {
							current.text = this.menu[this.currentIndex].FOLDER_NAME.toString().charAt(0);
						}
					}

					current.color = isNaN(this.currentSection) ? 'grey' : this.getColor( this.currentIndex );
				}

				return current;
			},
			desktopView() {
				return $(window).width() >= 650;
			}
		},
		methods: {
			toggleClassNav() {
				this.isMenuActive = !this.isMenuActive;
			},
			getColor( index ) {
				return this.menu && !!this.menu[index] ? this.menu[ index ].PAGE_ICON_COLOR: '';
			},
		},
		created() {
			const self = this;

			document.addEventListener('keyup',
				function( evt ) {
					if( self.isMenuActive ) {
						let charCode = ( evt.which ) ? evt.which : evt.keyCode;

						if( charCode === 27 ) {
							self.isMenuActive = false;
						}
					}
				}
			);
		}
	}
</script>

<style scoped>
.text-black{
	color:black !important;
}
.text-white{
	color:white !important;
}
</style>
